var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3876 2.69775C14.6706 2.69774 13.1813 4.38457 12 5.55434C10.8186 4.38457 9.32937 2.69774 6.61238 2.69775C3.8954 2.69777 1.08505 5.26135 1.22499 8.92364C1.22499 14.1241 8.27021 18.7019 12 21.3022C15.7298 18.7019 22.775 14.1241 22.775 8.92364C22.9149 5.26135 20.1046 2.69777 17.3876 2.69775Z",
    fill: "url(#paint0_radial_11804_61659)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_11804_61659",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.7273 2.69776) rotate(127.736) scale(23.525 28.2146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDCCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.330493,
    stopColor: "#CAC9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333117,
    stopColor: "#BAB9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630108,
    stopColor: "#BBB9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630208,
    stopColor: "#9E9CFE"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.9dc76e7ae83b92cb617acd610d68738c.svg";
export { ForwardRef as ReactComponent };